
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import { serverProps } from '@/Common/Environment/const';

	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import VueIframe from '@/HostApp/ui/system/VueIframe.vue';

	import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';

	@Component({
		components: { VueIframe }
	})
	export default class HelpCenterNode extends Vue {
		protected mounted(): void {
			window.addEventListener('message', helpCenterServiceModule.messageEventListener);
			this.$nextTick(() => {
				helpCenterServiceModule.computeNewArticlePath(this.viewId);
			});
		}

		protected get articlePath(): string {
			return helpCenterServiceModule.articlePath;
		}

		protected get isLoading(): boolean {
			return helpCenterServiceModule.isLoading;
		}

		protected get isHelpCenterEnabled(): boolean {
			return helpCenterServiceModule.isEnabled || false;
		}

		protected get iframeComputedStyles(): Partial<CSSStyleDeclaration> {
			return {
				height: helpCenterServiceModule.iframeHeight ? `${helpCenterServiceModule.iframeHeight}px` : ''
			};
		}

		protected get isHelpCenterOpened(): boolean {
			return helpCenterServiceModule.isHelpCenterOpened;
		}

		protected get helpMenu(): APS.IMenuItems | undefined {
			return serverProps.helpMenu;
		}

		protected get viewId(): string {
			const { context = [] } = aps.navigation?.tree || {};
			return context.length ? context[context.length - 1]?.viewId || '' : '';
		}

		protected get vueWorkspace(): boolean {
			return !!aps.navigation.vueWorkspace;
		}

		@Watch('viewId')
		protected onViewIdChanged(val: string): void {
			helpCenterServiceModule.computeNewArticlePath(val);
		}

		protected iframeLoadedHandler(loaded: boolean, vueIframe: HTMLIFrameElement): void {
			helpCenterServiceModule.setHelpCenterVueIFrame(vueIframe);
			helpCenterServiceModule.setIsLoading(false);
		}

		protected onDrawerClosed(): void {
			helpCenterServiceModule.setIsHelpCenterOpened(false);
		}
	}
